// Clamp a number between a minimum and maximum value.
export const clamp = (value, min = 0, max = 1) => Math.min(Math.max(value, min), max);

// Locate a number within the provided range that satisfies a condition (the
// predicate), where the next number less than a threshold distance away does
// NOT satisfy that condition.
//
// Uses binary search to minimize computation. Does not support ranges with more
// than one edge.
export const findEdge = (input, target, predicate, threshold) => {
  if (predicate(input)) {
    return input;
  }
  if (!predicate(target)) {
    return target;
  }
  let currentInput = input;
  let currentTarget = target;
  while (Math.abs(currentTarget - currentInput) > threshold) {
    const value = (currentInput + currentTarget) / 2;
    if (predicate(value)) {
      currentTarget = value;
    } else {
      currentInput = value;
    }
  }
  return currentTarget;
};